import React from 'react';

export default function BlogBlocksRenderer({ blocks }) {
  if (!blocks || !Array.isArray(blocks)) return null;

  return (
    <article className="prose prose-invert prose-lg max-w-none prose-headings:font-bold prose-headings:text-white prose-p:text-gray-300 prose-img:rounded-xl prose-img:border prose-img:border-white/10 prose-video:aspect-video prose-a:text-fuchsia-400 hover:prose-a:text-fuchsia-300 transition-colors">
      {blocks.map((block, idx) => {
        switch (block.type) {
          case 'heading': {
            const Tag = `h${Math.min(Math.max(block.level || 2, 1), 6)}`;
            return <Tag key={block.id || idx}>{block.content}</Tag>;
          }
          
          case 'paragraph':
            return <p key={block.id || idx}>{block.content}</p>;
            
          case 'image':
            return (
              <figure key={block.id || idx} className="my-8">
                <img 
                  src={block.url} 
                  alt={block.alt || ''} 
                  className="w-full h-auto rounded-xl shadow-lg border border-white/5"
                  loading="lazy"
                />
                {block.caption && (
                  <figcaption className="text-center text-sm text-gray-500 mt-3 italic">
                    {block.caption}
                  </figcaption>
                )}
              </figure>
            );

          case 'html':
            return (
              <div 
                key={block.id || idx} 
                dangerouslySetInnerHTML={{ __html: block.content }} 
                className="my-4"
              />
            );

          case 'video': {
            let embedSrc = block.url;
            
            const isYoutube = (block.platform === 'youtube') || (block.url && (block.url.includes('youtube.com') || block.url.includes('youtu.be')));

            // Basic YouTube ID extraction if full URL is pasted
            if (isYoutube && embedSrc) {
               let id = embedSrc;
               if (embedSrc.includes('v=')) {
                  id = embedSrc.split('v=')[1]?.split('&')[0];
               } else if (embedSrc.includes('youtu.be/')) {
                  id = embedSrc.split('youtu.be/')[1]?.split('?')[0];
               }
               embedSrc = `https://www.youtube.com/embed/${id}`;
            }

            return (
              <figure key={block.id || idx} className="my-8">
                <div className="aspect-video rounded-xl overflow-hidden shadow-lg border border-white/5 bg-black relative">
                  <iframe
                    width="100%"
                    height="100%"
                    src={embedSrc}
                    title="Video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="absolute inset-0 w-full h-full"
                  ></iframe>
                </div>
                {block.caption && (
                  <figcaption className="text-center text-sm text-gray-500 mt-3 italic">
                    {block.caption}
                  </figcaption>
                )}
              </figure>
            );
          }

          case 'youtube': // Legacy support
            return (
              <div key={block.id || idx} className="aspect-video my-8 rounded-xl overflow-hidden shadow-lg border border-white/5">
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${block.videoId}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            );

          default:
            return null;
        }
      })}
    </article>
  );
}
